module.exports = __webpack_public_path__ + "static/media/book-cover-journal.03fc6dd5.jpg";